import React from 'react';
import PropTypes from 'prop-types';
import {
  ERROR_CLASS,
  SMART_CLASS,
  DEFAULT_CLASS,
  SUCCESS_CLASS,
  DISABLED_CLASS,
} from 'constants/classNameConstants';
import { BodyMedium } from 'components/common_v2/typography';
import { LabelContainer, Label as StyledLabel } from './styled';

const Label = ({
  disabled,
  error,
  success,
  label,
  className,
  htmlFor,
  smart,
}) => {
  let labelClassName = DEFAULT_CLASS;
  if (smart) labelClassName = SMART_CLASS;
  if (error) labelClassName = ERROR_CLASS;
  if (success) labelClassName = SUCCESS_CLASS;
  if (disabled) labelClassName = DISABLED_CLASS;

  return (
    <LabelContainer className={className}>
      <StyledLabel htmlFor={htmlFor} className={labelClassName}>
        <BodyMedium className="bold" htmlFor={htmlFor}>
          {label}
        </BodyMedium>
      </StyledLabel>
    </LabelContainer>
  );
};

Label.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  success: PropTypes.bool,
  label: PropTypes.node,
  htmlFor: PropTypes.string,
  smart: PropTypes.bool,
};

Label.defaultProps = {
  className: undefined,
  disabled: false,
  error: false,
  success: false,
  label: undefined,
  htmlFor: undefined,
  smart: false,
};

export default Label;
